export enum UserEventsEnum {
  PRELOAD_TO_MAIN_GET_ME = 'PRELOAD_TO_MAIN_GET_ME',
  ON_NEW_UPDATE_RECORDING = 'ON_NEW_UPDATE_RECORDING',

  ON_UPDATE_RECORDING_START = 'ON_UPDATE_RECORDING_START',
  START_RECORDING = 'START_RECORDING',
  UPDATE_RECORDING = 'UPDATE_RECORDING',
  EXIT_RECORDING = 'EXIT_RECORDING',
  STOP_RECORDING = 'STOP_RECORDING',
  DESTROY_RECORDER = 'DESTROY_RECORDER',
  UPDATE_RECORDING_TAB = 'UPDATE_RECORDING_TAB',
  UPDATE_RECORDING_TAB_STARTED = 'UPDATE_RECORDING_TAB_STARTED',

  ON_URL_CHANGED = 'ON_URL_CHANGED',
  UPDATE_PAGE_TITLE = 'UPDATE_PAGE_TITLE',
  UPDATE_CURRENT_ASSET_URL = 'UPDATE_CURRENT_ASSET_URL',

  // BROWSER NAVIGATION
  REQUEST_BROWSER_NAVIGATION_HISTORY = 'REQUEST_BROWSER_NAVIGATION_HISTORY',
  GO_BACK = 'GO_BACK',
  GO_FORWARD = 'GO_FORWARD',
  ON_BROWSER_NAVIGATION_CHANGED = 'ON_BROWSER_NAVIGATION_CHANGED',
  ON_BROWSER_TITLE_CHANGED = 'ON_BROWSER_TITLE_CHANGED',
  GET_PAGE_TITLE = 'GET_PAGE_TITLE',
  GET_PAGE_URL = 'GET_PAGE_URL',
  RELOAD = 'RELOAD',
  STOP_RELOAD = 'STOP_RELOAD',
  VIEW_TO_APP_VIEW_DID_START_LOADING = 'VIEW_TO_APP_VIEW_DID_START_LOADING',
  VIEW_TO_APP_VIEW_DID_STOP_LOADING = 'VIEW_TO_APP_VIEW_DID_STOP_LOADING',
  VIEW_TO_APP_VIEW_DID_FINISH_LOAD = 'VIEW_TO_APP_VIEW_DID_FINISH_LOAD',
  PRELOAD_TO_MAIN_SUBMIT_URL = 'PRELOAD_TO_MAIN_SUBMIT_URL',
  MAIN_TO_RENDERER_OPEN_NEW_BROWSER_TAB = 'MAIN_TO_RENDERER_OPEN_NEW_BROWSER_TAB',

  LOG_OUT = 'LOG_OUT',
  RESIZE_BY_TYPE = 'RESIZE_BY_TYPE',
  FULL_SCREEN = 'FULL_SCREEN',

  // Organization
  PRELOAD_TO_MAIN_ORGANIZATION_CHANGED = 'PRELOAD_TO_MAIN_ORGANIZATION_CHANGED',
  PRELOAD_TO_MAIN_GET_SELECTED_ORGANIZATION = 'PRELOAD_TO_MAIN_GET_SELECTED_ORGANIZATION',
  PRELOAD_TO_MAIN_GET_ORGANIZATIONS = 'PRELOAD_TO_MAIN_GET_ORGANIZATIONS',

  // Permissions
  PRELOAD_TO_MAIN_GET_RECORDING_PERMISSIONS = 'PRELOAD_TO_MAIN_GET_RECORDING_PERMISSIONS',

  // Clones
  LOCAL_STORAGE_CHANGED = 'LOCAL_STORAGE_CHANGED',

  // Loader
  SET_LOADER = 'SET_LOADER',

  // Devtools
  OPEN_ALL_DEVTOOLS = 'OPEN_ALL_DEVTOOLS',
  OPEN_DEVTOOLS = 'OPEN_DEVTOOLS',

  // Auth
  PRELOAD_TO_MAIN_SET_CHALLENGE_VERIFIER = 'PRELOAD_TO_MAIN_SET_CHALLENGE_VERIFIER',
  MAIN_TO_RENDERER_GET_ACCESS_TOKEN = 'MAIN_TO_RENDERER_GET_ACCESS_TOKEN',
  MAIN_TO_RENDERER_GET_IS_AUTHENTICATED = 'MAIN_TO_RENDERER_GET_IS_AUTHENTICATED',

  // Persona
  MAIN_TO_RENDERER_GET_PERSONAS = 'MAIN_TO_RENDERER_GET_PERSONAS',
  RENDERER_TO_MAIN_SWITCH_ACTIVE_PERSONA = 'RENDERER_TO_MAIN_SWITCH_ACTIVE_PERSONA',
  RENDERER_TO_MAIN_CREATE_PERSONA = 'RENDERER_TO_MAIN_CREATE_PERSONA',
  RENDERER_TO_MAIN_EDIT_PERSONA = 'RENDERER_TO_MAIN_EDIT_PERSONA',
  RENDERER_TO_MAIN_SET_DEFAULT_PERSONA = 'RENDERER_TO_MAIN_SET_DEFAULT_PERSONA',
  RENDERER_TO_MAIN_RESET_PERSONA = 'RENDERER_TO_MAIN_RESET_PERSONA',
  RENDERER_TO_MAIN_DELETE_PERSONA = 'RENDERER_TO_MAIN_DELETE_PERSONA',
  MAIN_TO_RENDERER_PERSONAS_CHANGED = 'MAIN_TO_RENDERER_PERSONAS_CHANGED',

  // User activity
  RENDERER_TO_MAIN_USER_ACTIVITY = 'RENDERER_TO_MAIN_USER_ACTIVITY',
  MAIN_TO_RENDERER_USER_ACTIVITY = 'MAIN_TO_RENDERER_USER_ACTIVITY',
  // View
  RENDERER_TO_MAIN_SET_USER_AGENT = 'RENDERER_TO_MAIN_SET_USER_AGENT',
  RENDERER_TO_MAIN_GET_APP_VIEW_USER_AGENT = 'RENDERER_TO_MAIN_GET_APP_VIEW_USER_AGENT',
  RENDERER_TO_MAIN_SET_ZOOM_FACTOR = 'RENDERER_TO_MAIN_SET_ZOOM_FACTOR',
  RENDERER_TO_MAIN_SHOULD_SHOW_AFTER_LOGIN_MODAL = 'RENDERER_TO_MAIN_SHOULD_SHOW_AFTER_LOGIN_MODAL',
}
